(function () {
  'use strict';

  function initContact(root) {
    if (!root || root.getAttribute('data-nc-initialized')) return;
    root.setAttribute('data-nc-initialized', 'true');

    var revealEls = root.querySelectorAll('.nc-reveal:not(.nc-in)');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('nc-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('nc-in'); });
    }
  }

  function boot() {
    document.querySelectorAll('.naseebo-contact').forEach(initContact);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.naseebo-contact');
    if (root) initContact(root);
  });
})();